import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
//import { ButtonComponent } from "../../../components/Controls/Button/Button";
import * as actions from "../../../store/requests/actions";
import { avatar, men1, men2, men3, women1, women2, women3, warning, checkIcon, wrongIcon } from "../../../utils/images";
import TableGridView from "../../../components/TableGridView";
import Filterform from "./Filterform";
import "./style.scss";
import "../../Patients/style.scss";
import ClippedElement from "../../../components/CLippedElement";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import { ButtonComponent } from "../../../components/Controls/Button/Button";
import { requestStatisticsRequest } from "../../../store/dashboard/actions";
import { SelectComponent } from "../../../components/Controls/Select/Select";
import InputField from "../../../components/Controls/InputField/InputField";
import Loader from "../../../components/Loader/Loader";
import DialogComponent from "../../../components/Dialog/Dialog";

const AllRequests = ({ intl: { messages } }) => {
  const history = useHistory();
  const lang = localStorage.getItem("lang") || "en";
  const [searchValues, setSearchValues] = useState({});
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader);
  const [isOpen, setIsOpen] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [modalType, setModalType] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [reasonObjValue, setSelectedReasonObjValue] = useState({});
  const rejectionPayloadInitialize = {
    title: null,
    message: null,
    rejection_reason_id: null
  };
  const [rejectionPayload, setRejectionPayload] = useState(
    rejectionPayloadInitialize
  );
  const { allRequests, requestRejectionReasons, patient_id } = useSelector((state) => state.requests);
  const { requestStatistics } = useSelector((state) => state.dashboard);
  const [finishConfirmation, setFinishConfirmation] = useState(false);
  const [finishValidation, setFinishValidation] = useState(false);
  const mens = [men1, men2, men3];
  const womens = [women1, women2, women3];

  useEffect(() => {
    //rejected requests list
    dispatch(
      actions?.allRequestsRequest({
        page: 1,
        requestStatus: 0,
        sort: "created_at,desc",
      })
    );
    dispatch(requestStatisticsRequest())
    return () => {
      dispatch(actions.allRequestsReceive([]));
    };
  }, [dispatch]);

  //table n grid view render
  const headings = [
    messages.requests.patient_name,
    messages.requests.request_date,
    messages.requests.request_channel,
    messages.requests.request_status,
    messages.requests.actions,
  ];

  const renderTableData = () => {
    return allRequests?.data?.map((request, i) => {
      const { patient_name, created_at, request_source, request_status, request_status_name } =
        request;
      return [
        patient_name ? (
          <ClippedElement tooltipTitle={patient_name} >
            <span>{patient_name}</span>
          </ClippedElement>
        ) : (
          "-"
        ),
        created_at
          ? moment(created_at).format("DD[.]MM[.]YYYY  ,  HH:mm:ss")
          : "-",
        request_source ? request_source : "-",
        request_status_name ? request_status_name : "-",
        <ButtonComponent
          content={request_status === 1 ? messages.buttons.details : messages.patients.form.view_profile}
          type="button"
          classes={`cyan-button px-8`}
          handleClick={() => {
            if (request_status === 1) {
              setRequestData(request);
              setModalType("show");
              setIsOpen(true);
            } else if (request_status === 2) {
              history.push(`/patient-profile/${request.patient_id}`);
            } else {
              history.push(`/patient-preview/${request.patient_id}`);
            }
          }}
        />,
      ];
    });
  };
  const handlePageChange = (e, page) => {
    return dispatch(
      actions?.allRequestsRequest({
        page,
        requestStatus: 0,
        sort: "created_at,desc",
        ...searchValues,
      })
    );
  };
  const onImgError = (e, x) => {
    e.target.src = avatar;
  };
  const renderGridView = () => {
    if (allRequests?.data?.length > 0) {
      return allRequests.data.map((request, ind) => {
        const {
          patient_name,
          created_at,
          request_source,
          request_status,
          patient_image,
          patient_gender_type,
          request_status_name,
        } = request;
        return (
          <div className="col-md-4" key={ind}>
            <div className=" grid-col">
              <div className={`grid-col-img status${request_status || 0}`}>
                {patient_image !== null ? (
                  <img
                    src={patient_image}
                    alt="patient img"
                    onError={(e) => onImgError(e)}
                  />
                ) : (
                  <img src={patient_gender_type 
                    ? patient_gender_type === 1 ? mens[Math.floor(Math.random() * mens.length)] : patient_gender_type === 2 ? womens[Math.floor(Math.random() * womens.length)] : avatar
                    : avatar} alt="avatar img" />
                )}
                <span className="status-label">{request_status_name}</span>
              </div>
              <p className="patient_name">{patient_name}</p>
              <div className="d-flex justify-content-center">
                <p className="mx-3">{request_source}</p>
                <p className="">
                {messages.requests.date}: {moment(created_at).format("DD[.]MM[.]YYYY")}
              </p>
                {/* <p className="mx-3">{request_status}</p> */}
              </div>

              <ButtonComponent
                content={request_status === 1 ? messages.buttons.details : messages.patients.form.view_profile}
                type="button"
                classes={`cyan-button px-8`}
                handleClick={() => {
                  if (request_status === 1) {
                    setRequestData(request);
                    setModalType("show");
                    setIsOpen(true);
                  } else if (request_status === 2) {
                    history.push(`/patient-profile/${request.patient_id}`);
                  } else {
                    history.push(`/patient-preview/${request.patient_id}`);
                  }
                }}
              />
            </div>
          </div>
        );
      });
    } else {
      return <div className="grid_no_data">{messages.noData.no_data}</div>
    }
  };

  const SubmitRejectionReason = () => {
    if (
      (Object.values(rejectionPayload).filter((e) => e).length &&
        !Object.keys(rejectionPayload).includes("title") &&
        !Object.keys(rejectionPayload).includes("message")) || //1st senario
      (Object.values(rejectionPayload).filter((e) => e).length && //2nd senario
        Object.keys(rejectionPayload).includes("title") &&
        Object.keys(rejectionPayload).includes("message"))
    ) {
      dispatch(
        actions.rejectRequestRequest({
          id: requestData.id,
          data: rejectionPayload,
          setIsOpen,
        })
      );
    } else {
      setErrMsg(messages.requests.validation_reason);
    }
  };
  //1st modal show data
  const renderShowRequestDataModel = () => {
    return (
      <>
        <div className="col-md-12">
          <h4 className="text-center mb-10 text-bold">
            {messages.requests.new_request_to_appointment}
          </h4>
        </div>

        <div className="col-md-6 myform-group">
          <label className={`input-label ${lang === 'ar' ? 'rtl-label' : ''}`}>{messages.requests.name}</label>
          <input
            className={"disbale-input-text-color"}
            name="patient_name"
            value={requestData.patient_name}
            disabled={true}
          />
        </div>
        <div className="col-md-6 myform-group">
          <label className={`input-label ${lang === 'ar' ? 'rtl-label' : ''}`}>{messages.requests.phone}</label>
          <input
            className={"disbale-input-text-color phone_number"}
            name="patient_phone"
            value={requestData.patient_phone}
            disabled={true}
          />
        </div>
        <div className="col-md-12 myform-group">
          <label className={`input-label ${lang === 'ar' ? 'rtl-label' : ''}`}>{messages.requests.text_msg}</label>
          <textarea
            name="msg_text"
            className={"disbale-input-text-color"}
            value={requestData.message_text}
            disabled={true}
            rows={5}
          />
        </div>
        <div className="actions mt-10">
          <button className="cancel_btn"
            onClick={(e) => {
              e.preventDefault();
              setRejectionPayload(rejectionPayloadInitialize);
              setSelectedReasonObjValue({});
              dispatch(
                actions.requestRejectionReasonsRequest({
                  id: requestData.id,
                  setModal: () => setModalType("rejectReasonsScreen"),
                })
              );
            }}
          >{messages.buttons.reject} </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              dispatch(actions.acceptRequestRequest({ id: requestData.id }))
              setIsOpen(false);
              setFinishConfirmation(true);
            }}
          >{messages.buttons.accept}</button>
        </div>
      </>
    );
  };
  //2nd modal rejection reasons
  const renderRejectReasonsModal = () => {
    return (
      <>
        <div className="row w-100">
          <div className="col-md-12 text-center">
            <img src={wrongIcon} alt="wrong_icon" />
            <h4 className="my-3">{messages.requests.reject_request}</h4>
          </div>
          <div className="col-md-12 text-last-start">
            <SelectComponent form={true}
              size="small"
              name="requestSource"
              className={" form-control-solid  m-0 p-0 w-100"}
              list={[
                ...requestRejectionReasons,
                { id: 0, title: messages.common.add_new_reason },
              ]}
              keyName={"title"}
              valueKeyName="id"
              value={reasonObjValue.value}
              label={messages.requests.rejection_reason_placeholder}
              handleChange={(e, v) => {
                setErrMsg("");
                setSelectedReasonObjValue(e.target);
                // checkTypeOfReason(e.target.value);
                if (e.target.value !== 0) {
                  //exist reason
                  setRejectionPayload({
                    rejection_reason_id: e.target.value,
                  });
                } else {
                  setRejectionPayload({
                    title: "",
                    message: "",
                  });
                }
              }}
            />
          </div>
          {reasonObjValue?.value > 0 ? ( //new reason
            <div className="col-md-12 myform-group">
              <textarea
                className={"disbale-input-text-color"}
                name="request_rejection_reason"
                rows={3}
                value={
                  requestRejectionReasons?.find(
                    (elem) => elem.id === reasonObjValue.value
                  )?.message
                }
                disabled={true}
              />
            </div>
          ) : null}
          {reasonObjValue?.value === 0 ? ( //exist reason
            <>
              <div className="col-md-12">
                <InputField
                  size="small"
                  name="title"
                  label={messages.requests.new_rejection_reason_placeholder}
                  value={rejectionPayload.title}
                  changeHandler={(e) =>
                    setRejectionPayload({
                      message: rejectionPayload.message,
                      title: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-md-12">
                <InputField
                  name="msg"
                  className={"disbale-input-text-color"}
                  label={messages.requests.new_rejection_reason_description}
                  value={rejectionPayload.message}
                  isMultiline
                  changeHandler={(e) =>
                    setRejectionPayload({
                      title: rejectionPayload.title,
                      message: e.target.value,
                    })
                  }
                />
              </div>
            </>
          ) : null}
          {errMsg && (
            <div className="col-md-12 field-error-msg small text-danger semiBold-font text-last-start">
              {errMsg}
            </div>
          )}
          <div className="actions">
            <button className="cancel_btn"
              onClick={() => setModalType("confirm")} //handle are you sure
            >{messages.buttons.cancel}</button>
            <button
              onClick={() => SubmitRejectionReason()}
            >{messages.buttons.send}</button>
          </div>
        </div>
      </>
    );
  };
  //3rd modal are you sure you want to
  const renderAreYouSureConfirmModal = () => {
    return (
      <div className="m-auto w-75  d-flex flex-column justify-content-center align-items-center">
        <img src={warning} alt="warning" className="warning-icon mb-5" />
        <h6 className="bold-font text-center mb-4">
          {messages.warningMsgs.warning_close_window}
        </h6>
        <div className="">
          <div className="actions">
            <button className="cancel_btn"
              onClick={() => setModalType("rejectReasonsScreen")}
            >{messages.buttons.no}</button>
             <button onClick={() => {
                setErrMsg("");
                setIsOpen(false);
              }}
            >{messages.buttons.yes}</button>
          </div>
        </div>
      </div>
    );
  };
  const renderModalContent = () => {
    return (
      <div className="row px-5 py-4 justify-content-center">
        {loading ? (
          <Loader className={"loader center-vertical"} />
        ) : modalType === "show" ? (
          renderShowRequestDataModel()
        ) : modalType === "rejectReasonsScreen" ? (
          renderRejectReasonsModal()
        ) : modalType === "confirm" ? (
          renderAreYouSureConfirmModal()
        ) : null}
      </div>
    );
  };
  
  return (
    <>
      {allRequests ? (
        <TableGridView
          title={
            <>
              <FormattedMessage
                values={{
                  total: allRequests?.total,
                  totals: (requestStatistics?.new + requestStatistics?.inprogress + requestStatistics?.canceled +  + requestStatistics?.rejected + requestStatistics?.completed),
                }}
                id="requests.request_of"
                defaultMessage={messages.requests.request_of}
              />
            </>
          }
          Form={<Filterform setSearchValues={setSearchValues} />}
          table={{
            stickyHeader: true,
            headings: headings,
            data: renderTableData(),
            headClass: "bg-white table-head",
            noData: messages.noData.no_data,
          }}
          gridView={renderGridView}
          defaultView="grid"
          pagination={{
            count: allRequests.last_page,
            page: allRequests.current_page,
            handleChange: handlePageChange,
          }}
        />
      ) : null}
      <DialogComponent
        open={isOpen}
        handleClose={() => {
          setErrMsg("");
          setSelectedReasonObjValue({});
          setRejectionPayload(rejectionPayloadInitialize);
          setIsOpen(false);
        }}
        content={renderModalContent()}
      />
      <ConfirmDialog show={finishConfirmation} 
                     onCancel={() => {
                        setFinishValidation(true)
                        setFinishConfirmation(false)
                      }}
                     onConfirm={() => {
                        setFinishConfirmation(false);
                        history.push(`/patient-profile/${patient_id}`);
                     }}
                     icon={checkIcon}
                     content={messages.requests.request_confirmation}
                     cancelBtn={messages.requests.request_confirmation_close}
                     confirmBtn={messages.requests.request_confirmation_btn} />
      <ConfirmDialog show={finishValidation} 
                     onCancel={() => {
                        setFinishValidation(false)
                        setFinishConfirmation(true)
                      }}
                     onConfirm={() => {
                        setFinishValidation(false);
                     }}
                     icon={warning}
                     content={messages.requests.finish_validation_msg}
                     cancelBtn={messages.common.cancel}
                     confirmBtn={messages.common.confirm} />
    </>
  );
};

export default injectIntl(AllRequests);
